<xvi-base-array-string-renderer
  [stringValue]="stringValue"
  [items]="items"
  [wrapperClass]="wrapperClass"
  [itemClass]="itemClass"
  [allButton]="allButton"
  [linkClick]="linkClick"
  (dropdownMenuClick)="handleDropDownMenuClick($event)"
>
</xvi-base-array-string-renderer>
